import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

const isEntityIdCleanupEnabled = () =>
  isFeatureFlagEnabled(FEATURE_FLAGS.entityIdCleanup);

export const getGroupingIdConfig = () => {
  const enabled = isEntityIdCleanupEnabled();
  return {
    /** The response field to read from decisions */
    responseField: enabled ? "grouping_id" : "entity_id",
    /** The display label for the column */
    label: enabled ? "Grouping ID" : "Entity ID",
    /** The label prefixed with the correct article */
    labelWithArticle: enabled ? "a Grouping ID" : "an Entity ID",
    /** The query parameter name for the v3 history API */
    queryParam: enabled ? "groupingIds" : "entityIds",
    /** The query parameter name for the v2 summary API */
    summaryParam: enabled ? "grouping_id" : "entity_id",
  } as const;
};
